import type { PopoverProps as MuiPopoverProps } from '@mui/material';
import { Box, Paper, Popover, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { Show } from '../../../../../components/Show';
import type { WithChildrenProps } from '../../../../../types/components/common';
import { getIsUsPlatform } from '../../../../../utils';
import { usePlatformLanguage } from '../../../../../utils/hooks/usePlatformLanguage';
import {
  ResourcesMenuOptions,
  YourAgencyMenuOptions,
} from './AgencyMenuOptionsPopover';
import {
  AdministrativeMenuOptions,
  LicensesMenuOptions,
  TechnicalMenuOptions,
} from './ToolsPopover';

interface PopoverProps extends MuiPopoverProps {
  onClose: () => void;
}

export const AgencyDashboardMegaMenu = (popoverState: PopoverProps) => {
  const classes = useStyles({ isOpen: popoverState.open });
  const region = usePlatformLanguage();
  const isUSPlatform = getIsUsPlatform(region);

  const handleMenuOptionClick = () => {
    popoverState.onClose();
  };

  return (
    <Popover
      id="mega-menu"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      style={{ position: 'absolute', top: '1rem', left: '-5rem' }}
      {...popoverState}
    >
      <Paper style={{ display: 'flex' }} className={classes.paper}>
        <Box className={classes.highlight} />
        <Box display="flex" style={{ padding: '2rem' }}>
          <Box width="18rem">
            <img
              src="logos/CowbellLogo.svg"
              style={{ width: '7rem', marginBottom: '1rem' }}
              alt=""
            />
            <Typography variant="body2">
              Adaptive Cyber Insurance for today's and tomorrow's threats
            </Typography>
          </Box>
          <MenuSection width="12rem">
            <YourAgencyMenuOptions onClick={handleMenuOptionClick} />
          </MenuSection>
          <Box display="flex" flexDirection="column">
            <MenuSection width="15rem">
              <ResourcesMenuOptions onClick={handleMenuOptionClick} />
            </MenuSection>
            <br />
            <Show when={isUSPlatform}>
              <MenuSection width="15rem">
                <LicensesMenuOptions onClick={handleMenuOptionClick} />
              </MenuSection>
            </Show>
          </Box>
          <MenuSection width="15rem">
            <AdministrativeMenuOptions onClick={handleMenuOptionClick} />
          </MenuSection>
          <MenuSection width="12rem">
            <TechnicalMenuOptions onClick={handleMenuOptionClick} />
          </MenuSection>
        </Box>
      </Paper>
    </Popover>
  );
};

const useStyles = makeStyles((theme) => ({
  highlight: { backgroundColor: theme.agencyDash.icon, width: 8 },
  paper: { backgroundColor: theme.agencyDash.background.menu },
}));

const MenuSection = ({
  children,
  width,
}: WithChildrenProps & { width: string | number }) => {
  const theme = useTheme<any>();
  return (
    <Box
      width={width}
      style={{ borderLeft: `1px solid ${theme.agencyDash.border.divider}` }}
    >
      {children}
    </Box>
  );
};
